'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var withStyles = require('../../Styles/withStyles.js');
var SvgIcon = require('../../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');
var colorManipulator = require('../../../node_modules/@material-ui/core/esm/styles/colorManipulator.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Matches pulse styling from @material-ui/lab/Skeleton
 *
 * https://github.com/mui-org/material-ui/blob/79ebf71d31cca2c73143891960ea54ec1132bdeb/packages/material-ui-lab/src/Skeleton/Skeleton.js#L33-L46
 * https://github.com/mui-org/material-ui/blob/79ebf71d31cca2c73143891960ea54ec1132bdeb/packages/material-ui-lab/src/Skeleton/Skeleton.js#L11
 */

var styles = function styles(theme) {
  return {
    pulse: {
      animation: '$pulse 1.5s ease-in-out 0.5s infinite'
    },
    '@keyframes pulse': {
      '0%': {
        opacity: 1
      },
      '50%': {
        opacity: 0.4
      },
      '100%': {
        opacity: 1
      }
    }
  };
};

var SVGSkeleton = function SVGSkeleton(_ref) {
  var classes = _ref.classes,
      theme = _ref.theme,
      props = objectWithoutProperties(_ref, ["classes", "theme"]);

  return React__default["default"].createElement(SvgIcon["default"], _extends["default"]({
    viewBox: "0 0 32 16"
  }, props), React__default["default"].createElement("rect", {
    className: classes.pulse,
    width: "32",
    height: "16",
    fill: colorManipulator.fade(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
    rx: "8"
  }));
};

var SVGSkeleton$1 = withStyles["default"](styles, {
  withTheme: true
})(SVGSkeleton);
SVGSkeleton.defaultProps = {
  width: "32",
  height: "16"
};

module.exports = SVGSkeleton$1;
